export default __webpack_public_path__ + "static/media/social-01@2x.070271fc.webp";